import MuiButton, { type ButtonProps as MuiButtonProps } from '@mui/material/Button'
import MuiIconButton, { type IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton'
import MuiToggleButton, { type ToggleButtonProps as MuiToggleButtonProps } from '@mui/material/ToggleButton'

//* BUTTON
export const Button = MuiButton
export type ButtonProps = MuiButtonProps

//* ICON BUTTON
export const IconButton = MuiIconButton
export type IconButtonProps = MuiIconButtonProps

//* TOGGLE BUTTON
export const ToggleButton = MuiToggleButton
export type ToggleButtonProps = MuiToggleButtonProps
